import React from "react";
import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useSnackbar } from "@components";
import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import {
  Refresh as RefreshIcon,
  FileDownload as FileDownloadIcon,
  Cancel as CancelIcon,
  SendOutlined,
  SearchOutlined,
} from "@mui/icons-material";

import {
  downloadWfCheckpointFilesById,
  generateWfCheckpointPdfReportbyId,
  getAllClientsNoPagination,
  getClientIdByToken,
  useWorkflowContainerCheckPoints,
  validTaskCodeByToken,
  workflowContainerCheckPointDelete,
} from "../../../../libs/apis";
import {
  ClientI,
  WorkflowContainerCheckPointI,
} from "../../../../libs/interfaces";
import {
  HEIGHT_TABLE_CONTAINER,
  TASK_CHECKPOINT_CREATE_PDF,
  TASK_CHECKPOINT_EDIT_CODE,
  TASK_CHECKPOINT_FILTER_LIST,
} from "../../../../libs/constants";
import {
  ButtonQr,
  ExcelComponent,
  NetworkStatusAlert,
  PdfElement,
  SendReport, ToolbarFilters } from "../../../../libs/shared";
import { useWidth } from "../../../../libs/hooks";
import { useNavigate } from "react-router-dom";
import "../../../../libs/css/list.css";
import {
  Button as ButtonAntd,
  Tooltip as TooltipAntd,
  Popconfirm,
  message,
  Select,
  DatePicker,
} from "antd";
import {
  DeleteFilled,
  EditOutlined,
  FilePdfOutlined,
  FileZipFilled,
} from "@ant-design/icons";
import { ShowContainer } from "./show-container";

const titleExport = "ContenedorFull";
const routeEdit = "/container/checkpoint/edit/";
const { RangePicker } = DatePicker;

const WorkflowListComponent = () => {
  const width = useWidth();
  const isMobile = width === "xs" || width === "sm";
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const { enqueueSnackbar } = useSnackbar();
  const [sorting, setSorting] = React.useState([{ id: "id", desc: true }]);
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: width === "ab" ? 25 : width === "xl" ? 20 : 15,
  });
  const [globalFilter, setGlobalFilter] = React.useState("");
  const [client, setClient] = React.useState<any>(null);
  const [clients, setClients] = React.useState<ClientI[]>([]);
  const [range, setRange] = React.useState([] as unknown as [string, string]);
  const [rangeVal, setRangeVal] = React.useState<any>([]);
  const { workflowContainerCheckPointsQuery } = useWorkflowContainerCheckPoints(
    {
      sorting,
      pagination,
      globalFilter,
      client,
      range,
      rangeVal,
    }
  );
  const { data, isLoading, refetch, isFetching, isRefetching } =
    workflowContainerCheckPointsQuery;
  const [rowSelection, setRowSelection] = React.useState({});

  const [isDeleting, setDeleting] = React.useState(false);
  const [getExportData, setExportData] = React.useState([]);
  const [getExportHeader, setExportHeader] = React.useState([]);
  const [isContinuoToExport, setContinuoToExport] = React.useState(false);
  const [isReadyExport, setReadyExport] = React.useState(false);
  const [isGeneratingPdf, setGeneratingPdf] = React.useState(false);
  const [showExporters, setShowExporters] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(false);
  const [showPdf, setShowPdf] = React.useState(false);
  const [downloadFile, setDownloadFile] = React.useState<boolean>(false);

  React.useLayoutEffect(() => {
    handleGetTask();
  }, []);

  React.useEffect(() => {
    handleGetData();
    return () => {
      setShowExporters(false);
    };
  }, []);

  React.useEffect(() => {
    if (isContinuoToExport) {
      setContinuoToExport(false);
      setReadyExport(true);
    }
  }, [isContinuoToExport]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleGetData = async () => {
    try {
      const { data: dataClient } = await getClientIdByToken();
      if (dataClient) {
        setClient(dataClient);
      }

      const { data: dataTask } = await validTaskCodeByToken(
        TASK_CHECKPOINT_FILTER_LIST
      );

      if (!dataTask) return;
      if (dataTask.status) {
        setShowExporters(true);
        const { data: dataClients } = await getAllClientsNoPagination();
        if (!dataClients) return;
        setClients(dataClients);
      }

      const { data: dataTaskPdf } = await validTaskCodeByToken(
        TASK_CHECKPOINT_CREATE_PDF
      );

      if (!dataTaskPdf) return;
      if (dataTaskPdf.status) {
        setShowPdf(true);
      }
    } catch (err: any) {
      message.error(`Error: ${err.toString()}`);
    }
  };

  const handleGetTask = async () => {
    try {
      const { data: dataTask } = await validTaskCodeByToken(
        TASK_CHECKPOINT_EDIT_CODE
      );

      if (!dataTask) return;
      if (dataTask.status) {
        setShowEdit(true);
      } else {
        setShowEdit(false);
      }
    } catch (err: any) {
      setShowEdit(false);
      message.error(`Error: ${err.toString()}`);
    }
  };

  const columns = React.useMemo<MRT_ColumnDef<WorkflowContainerCheckPointI>[]>(
    () => [
      {
        accessorKey: "container",
        id: "container",
        header: "Contenedor",
        minSize: 100,
        size: 200,
        enableClickToCopy: true,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            <a
              className="b-proform"
              // onClick={() => handleNavigate(row.original)}
            >
              {renderedCellValue}
            </a>
          </Box>
        ),
      },
      {
        accessorKey: "client",
        id: "client",
        header: "Cliente",
        minSize: 150,
        size: 150,
        enableClickToCopy: true,
      },
      {
        accessorKey: "createdAt",
        id: "createdAt",
        header: "Creacion",
        minSize: 150,
        size: 150,
      },
      {
        accessorKey: "userCreation",
        id: "userCreation",
        header: "Usuario Creación",
        minSize: 100,
        size: 200,
      },
    ],
    []
  );

  const handleDeleteRow = React.useCallback(
    async (row: WorkflowContainerCheckPointI) => {
      setDeleting(true);
      try {
        const { data: dataWorkflow } = await workflowContainerCheckPointDelete(
          row.id!
        );
        enqueueSnackbar(dataWorkflow, { variant: "success" });
        refetch();
        setDeleting(false);
      } catch (err) {
        enqueueSnackbar((err as Error).message, { variant: "error" });
        setDeleting(false);
      }
    },
    []
  );

  const handleDownloadFiles = React.useCallback(
    async (row: WorkflowContainerCheckPointI): Promise<void> => {
      // Validar si estamos en modo offline

      try {
        // Recibe el blob desde la API
        setDownloadFile(true);
        const blobData = await downloadWfCheckpointFilesById(row.id!);

        // Crea un objeto URL para el blob
        const url = window.URL.createObjectURL(blobData! as any);
        setDownloadFile(false);

        // Crea un enlace invisible
        const a = document.createElement("a");
        a.href = url;
        a.download = `reporte_${row.container || ""}_${row.id}.zip`; // Nombre del archivo
        document.body.appendChild(a);

        // Simula un clic para iniciar la descarga
        a.click();

        // Limpia
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        message.success("Archivo descargado correctamente", 1);
        message.success("Archivo descargado", 1);
      } catch (err) {
        setDownloadFile(false);
        enqueueSnackbar((err as Error).message, { variant: "error" });
      }
    },
    [enqueueSnackbar, refetch]
  );

  const handleExportRows = (rows: any, columnsShow: any) => {
    const headersActive = columnsShow
      .slice(2)
      .filter((el: any) => el.getIsVisible())
      .map((el: any) => ({
        label: el.columnDef.header,
        id: el.columnDef.id,
        width: el.columnDef.size,
        textAlign: "left",
        show: true,
        fontSize: "10px",
      }));

    rows = rows.map((el: any) => el.original);

    setExportData(rows);
    setExportHeader(headersActive);
    setContinuoToExport(true);
  };

  const handleClickPdf = () => {
    setTimeout(() => {
      setReadyExport(false);
      setExportData([]);
      setExportHeader([]);
    }, 1500);
  };

  const handleResetExport = () => {
    setReadyExport(false);
    setExportData([]);
    setExportHeader([]);
  };

  const handleNavigate = React.useCallback(
    (row: WorkflowContainerCheckPointI) => {
      const routePath = routeEdit + row.id;
      navigate(routePath);
    },
    []
  );

  const handlePdf = async (row: WorkflowContainerCheckPointI) => {
    try {
      setGeneratingPdf(true);

      messageApi.open({
        key: "generatePdfKey1",
        type: "loading",
        content: "Generando Pdf",
        duration: 20,
      });

      const { data: dataPdf } = await generateWfCheckpointPdfReportbyId(
        row.id!
      );
      messageApi.destroy("generatePdfKey1");
      messageApi.open({
        key: "generatePdfKey4",
        type: "loading",
        content: "Procesando Pdf",
        duration: 1,
        onClose: () => {
          message.success("PDF Descargado", 1);
        },
      });

      const downloadLink = document.createElement("a");
      downloadLink.target = "__blank";
      downloadLink.href = `data:application/pdf;base64,${dataPdf}`;
      downloadLink.download = `Reporte-Checkpoint-Contenedor-${row.container}.pdf`;
      downloadLink.click();
      setGeneratingPdf(false);
    } catch (err: any) {
      messageApi.destroy();
      setGeneratingPdf(false);
      message.error(`Error al generar el pdf: ${err.toString()}`);
    }
  };

  const handleSetClient = React.useCallback((client: number | null) => {
    setClient(client);
  }, []);

  // Función para generar múltiples PDFs
  const handleMultiplePdf = async (
    selectedRows: WorkflowContainerCheckPointI[]
  ) => {
    try {
      setGeneratingPdf(true);
      messageApi.open({
        key: "generateMultiplePdfKey",
        type: "loading",
        content: `Generando ${selectedRows.length} PDFs...`,
        duration: 0,
      });

      // Procesar cada PDF de manera secuencial para evitar sobrecarga
      for (let i = 0; i < selectedRows.length; i++) {
        const row = selectedRows[i];

        // Actualizar mensaje para mostrar progreso
        messageApi.open({
          key: "generateMultiplePdfKey",
          type: "loading",
          content: `Generando PDF ${i + 1} de ${selectedRows.length}: ${
            row.container
          }`,
          duration: 0,
        });

        try {
          const { data: dataPdf } = await generateWfCheckpointPdfReportbyId(
            row.id!
          );

          // Descargar el PDF
          const downloadLink = document.createElement("a");
          downloadLink.href = `data:application/pdf;base64,${dataPdf}`;
          downloadLink.target = "__blank";
          downloadLink.download = `Reporte-Contenedor-Checkpoint-${row.container}.pdf`;
          downloadLink.click();

          // Pequeña pausa para dar tiempo al navegador
          await new Promise((resolve) => setTimeout(resolve, 500));
        } catch (err) {
          console.error(`Error al generar PDF para ${row.container}:`, err);
          // Continuar con el siguiente PDF incluso si este falla
        }
      }

      messageApi.destroy("generateMultiplePdfKey");
      message.success(`Se generaron ${selectedRows.length} PDFs`, 3);
    } catch (err: any) {
      messageApi.destroy("generateMultiplePdfKey");
      message.error(`Error al generar los PDFs: ${err.toString()}`);
    } finally {
      setGeneratingPdf(false);
    }
  };

  return (
    <>
      {contextHolder}
      <NetworkStatusAlert onRefresh={refetch} />

      <MaterialReactTable
        displayColumnDefOptions={{
          "mrt-row-actions": {
            muiTableHeadCellProps: {
              align: "center",
            },
            muiTableBodyCellProps: {
              align: "center",
            },
            size: showEdit ? 210 : 90,
            minSize: showEdit ? 210 : 90,
            maxSize: showEdit ? 210 : 90,
          },
        }}
        //OPTIONS
        enableStickyHeader
        enableStickyFooter
        enableDensityToggle
        enableColumnOrdering
        enableColumnResizing
        enableEditing
        enableGlobalFilter
        enableColumnFilters={false}
        enableRowSelection
        manualFiltering
        manualPagination
        manualSorting
        muiSearchTextFieldProps={{
          placeholder: "Buscar...",
          size: "small", // Campo más pequeño
          variant: "outlined",
          InputProps: {
            startAdornment: isMobile ? null : <SearchOutlined />, // Quita el icono de la lupa
          },
          style: {
            width: isMobile ? "80px" : "170px", // Ancho fijo usando style en lugar de sx
            minWidth: isMobile ? "80px" : "170px",
            maxWidth: isMobile ? "80px" : "170px",
            margin: "0px",
          },
        }}
        muiTableContainerProps={({ table }) => {
          return {
            sx: {
              minHeight: table.options.state.isFullScreen
                ? `calc(100vh - 100px)`
                : `calc(100vh - ${HEIGHT_TABLE_CONTAINER})`,
              maxHeight: table.options.state.isFullScreen
                ? `calc(100vh - 100px)`
                : `calc(100vh - ${HEIGHT_TABLE_CONTAINER})`,
              height: table.options.state.isFullScreen
                ? `calc(100vh - 100px)`
                : `calc(100vh - ${HEIGHT_TABLE_CONTAINER})`,
            },
          };
        }}
        columns={columns}
        data={data?.data?.dato ?? []}
        initialState={{
          density: "compact",
          rowSelection,
          sorting,
          showColumnFilters: false,
        }}
        state={{
          isLoading: isLoading || isFetching || isRefetching,
          globalFilter,
          rowSelection,
          pagination,
          sorting,
          showColumnFilters: false,
        }}
        rowCount={data?.data?.total ?? 0}
        onRowSelectionChange={setRowSelection}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        onGlobalFilterChange={setGlobalFilter}
        renderTopToolbarCustomActions={({ table }) => (
          <Grid
            alignItems="center"
            container
            justifyContent="flex-start"
            spacing={1}
            sx={{ width: "auto" }}
          >
            <Grid item>
              <Tooltip title="Refrescar">
                <span>
                  <IconButton onClick={() => refetch()} color="warning">
                    <RefreshIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item>
              <ToolbarFilters>
                <FiltersComponent
                  showExporters={showExporters}
                  width={width}
                  clients={clients}
                  setClient={handleSetClient}
                  rangeVal={rangeVal}
                  setRangeVal={setRangeVal}
                  setRange={setRange}
                />
              </ToolbarFilters>
            </Grid>
            {(table.getIsSomeRowsSelected() ||
              table.getIsAllRowsSelected()) && (
              <Grid item>
                <TooltipAntd title="Generar PDF para seleccionados">
                  <ButtonAntd
                    type="primary"
                    icon={<FilePdfOutlined />}
                    loading={isGeneratingPdf}
                    disabled={isGeneratingPdf}
                    onClick={() =>
                      handleMultiplePdf(
                        table
                          .getSelectedRowModel()
                          .rows.map((row) => row.original)
                      )
                    }
                  >
                    PDFs ({table.getSelectedRowModel().rows.length})
                  </ButtonAntd>
                </TooltipAntd>
              </Grid>
            )}
            <Grid item sx={{ display: "grid", placeContent: "center" }}>
              <Tooltip arrow title="Export Data">
                <span>
                  <IconButton
                    disabled={
                      (!table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()) ||
                      isReadyExport
                    }
                    onClick={() =>
                      handleExportRows(
                        table.getSelectedRowModel().rows,
                        table.getAllColumns()
                      )
                    }
                    color="success"
                  >
                    <FileDownloadIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
            <Grid item sx={{ display: "grid", placeContent: "center" }}>
              {isReadyExport ? (
                <PdfElement
                  data={getExportData}
                  headersColumn={getExportHeader}
                  HandleClickPdf={handleClickPdf}
                  isSmall={true}
                />
              ) : null}
            </Grid>
            <Grid item sx={{ display: "grid", placeContent: "center" }}>
              {isReadyExport ? (
                <ExcelComponent
                  data={getExportData}
                  titulo={titleExport}
                  headersColumn={getExportHeader}
                  isEcuafact={false}
                />
              ) : null}
            </Grid>
            <Grid item sx={{ display: "grid", placeContent: "center" }}>
              {isReadyExport ? (
                <Tooltip arrow title="Cancelar Exportación" placement="top">
                  <IconButton
                    onClick={handleResetExport}
                    style={{ backgroundColor: "#ECF0F1 ", color: "red" }}
                  >
                    <CancelIcon />
                  </IconButton>
                </Tooltip>
              ) : null}
            </Grid>
          </Grid>
        )}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: "flex", gap: "0.4rem" }}>
            {showEdit ? (
              <>
                <TooltipAntd arrow={false} title="Editar">
                  <ButtonAntd
                    type="dashed"
                    size="small"
                    shape="circle"
                    onClick={() => handleNavigate(row.original)}
                    icon={<EditOutlined />}
                  />
                </TooltipAntd>
                <TooltipAntd arrow={false} title="Multimedia">
                  <ButtonAntd
                    type="dashed"
                    size="small"
                    shape="circle"
                    onClick={() => handleDownloadFiles(row.original)}
                    icon={<FileZipFilled />}
                    loading={downloadFile}
                    disabled={downloadFile}
                  />
                </TooltipAntd>
                <TooltipAntd arrow={false} title="Eliminar">
                  <Popconfirm
                    title="Eliminar Contenedor Full"
                    description="Seguro desea eliminar este Contenedor Full?"
                    onConfirm={() => handleDeleteRow(row.original)}
                    okText="Si"
                    cancelText="No"
                  >
                    <ButtonAntd
                      type="dashed"
                      danger
                      loading={isDeleting}
                      disabled={isDeleting}
                      size="small"
                      shape="circle"
                      icon={<DeleteFilled />}
                    />
                  </Popconfirm>
                </TooltipAntd>
                <SendReport id={row.original.id!} typeWf="checkpoint" />
                <ButtonQr
                  item={row.original}
                  concatLink="workflow-checkpoint/"
                />
              </>
            ) : null}
            {showPdf ? (
              <ButtonAntd
                loading={isGeneratingPdf}
                disabled={isGeneratingPdf}
                size="small"
                type="dashed"
                onClick={() => handlePdf(row.original)}
                icon={<FilePdfOutlined />}
              />
            ) : null}
            <ShowContainer id={row.original.id!} />
          </Box>
        )}
        localization={MRT_Localization_ES}
        // OPTIONS SELECTION ROW
        selectAllMode="all"
        positionToolbarAlertBanner="none"
      />
    </>
  );
};

interface FiltersComponentI {
  showExporters: boolean;
  width: string;
  clients: ClientI[];
  setClient: (client: number | null) => void;
  rangeVal: any;
  setRangeVal: any;
  setRange: any;
}

const FiltersComponent = React.memo(
  ({
    showExporters,
    width,
    clients,
    setClient,
    rangeVal,
    setRangeVal,
    setRange,
  }: FiltersComponentI) => {
    const [clientName, setClientName] = React.useState<any>(null);

    return (
      <>
        <Grid item>
          <RangePicker
            value={rangeVal}
            onChange={(dates, date) => {
              setRangeVal(dates);
              setRange(date);
            }}
          />
        </Grid>
        {showExporters ? (
          <Grid item>
            <Select
              showSearch
              allowClear
              dropdownStyle={{ zIndex: 1300 }}
              style={{
                width: width === "xs" ? 300 : 250,
                minWidth: width === "xs" ? 300 : 250,
              }}
              placeholder="Exportador"
              optionFilterProp="label"
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={clients.map((el) => ({
                label: el.name,
                value: el.name,
              }))}
              value={clientName}
              onChange={(value) => {
                setClientName(value);
                const findProducer = clients.find((el) => el.name === value);
                if (findProducer) {
                  setClient(findProducer.id!);
                } else {
                  setClient(null);
                }
              }}
            />
          </Grid>
        ) : null}
      </>
    );
  }
);

export default WorkflowListComponent;
